import { gql } from '@lcs/shared/api';

export const getLocationDetail = gql`
   query GetLocationDetail($id: UInt!) {
      location(id: $id) {
         locationId
         account {
            accountId
            name
            timeZoneId
         }
         name
         address
         houseNumber
         directionalPrefix
         streetName
         streetNameSuffix
         directionalPostfix
         city
         comment
         state
         postalCode
         country
         timeZoneId
         displayTimeZone
         isE911Validated
         mostRecentE911ValidationResponse
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
   }
`;
